import React from "react";
import { FiX } from "react-icons/fi";
import { toast } from "react-toastify";
import { SHA256 } from "crypto-js";
import { useDispatch, useSelector } from "react-redux";
import {
  uploadLogoDetails,
  getDefalutLogos,
} from "../../../../../../Redux/actions/projectActions";
import CustomToast from "../../../../../../Components/CustomToast/CustomToast";
import { customToatStyle } from "../Logos";
import "../../../OptionFont/FontComponent/UploadFontModal.css";

const UpdateLogoEdit = ({
  setIsUploadingModal,
  file,
  setFile,
  setReLoading,
  setAlertModal,
  currentBlockIdx,
}) => {
  const projectData = useSelector((state) => state.project?.credits);
  const dispatch = useDispatch();
  const isCard = JSON.parse(localStorage.getItem("isCard"));

  const handleNo = () => {
    setIsUploadingModal(false);
    setFile({});
  };

  const handleUploadLogo = async (selectedFile) => {
    if (
      selectedFile?.type !== "image/jpeg" &&
      selectedFile?.type !== "image/png" &&
      selectedFile?.type !== "image/jpg"
    ) {
      setAlertModal(true);
      return;
    }

    setIsUploadingModal(false);
    const creditID = projectData ? projectData[currentBlockIdx]?._id : "";
    const fileName = selectedFile.name + Date.now();
    const fileType = selectedFile.type;
    const fileArrayBuffer = await selectedFile.arrayBuffer();
    const fileUint8Array = new Uint8Array(fileArrayBuffer);
    const sha256Hash = SHA256(fileUint8Array).toString();

    if (!fileName || !fileType) {
      toast.error("File Not Selected");
      return;
    }

    await setReLoading({ condn: true, label: "Uploading..." });
    const formData = new FormData();
    formData.append("fileName", fileName);
    formData.append("fileType", fileType);
    formData.append("creditID", creditID);
    formData.append("file", selectedFile);
    formData.append("shKey", sha256Hash);
    formData.append("isCard", isCard);

    const res = await dispatch(uploadLogoDetails(formData, creditID));
    if (res?.success) {
      await dispatch(getDefalutLogos());
      toast(
        <CustomToast title="" content={"Logo uploaded successfully !"} />,
        customToatStyle,
      );
      await setReLoading({ condn: false, label: "" });
    } else {
      await setReLoading({ condn: false, label: "" });
      console.log(" Error ", res);
    }
  };

  return (
    <div className="ufm-root" role="dialog" aria-modal="true">
      <div className="ufm-overlay" onClick={handleNo} />
      <div className="ufm-panel">
        <button
          type="button"
          className="ufm-close"
          onClick={handleNo}
          aria-label="Close"
        >
          <FiX size={16} strokeWidth={2.25} />
        </button>

        <div className="ufm-header">
          <h2 className="ufm-title">Please confirm the following</h2>
          <p className="ufm-copy">
            By uploading my own custom logo, I acknowledge that I own{" "}
            <strong className="ufm-filename">{file?.name}</strong> or have the
            right to use it for my intended purposes.
          </p>
        </div>

        <div className="ufm-actions">
          <button
            type="button"
            className="ufm-btn ufm-btn--cancel"
            onClick={handleNo}
          >
            Cancel
          </button>
          <button
            type="button"
            className="ufm-btn ufm-btn--confirm"
            onClick={() => handleUploadLogo(file)}
          >
            Yes, upload it
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateLogoEdit;
